module.exports = __webpack_public_path__ + "static/item--blinds--f2@3x.4af24615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--blinds--f2@3x.png
// module id = 629
// module chunks = 126511778744290